import React from 'react';
import PropTypes from 'prop-types';
// import { colors } from '../../../css';

function SupplierFeatureTwo(props) {
  const { height, width, iconColor, backgroundColor } = props;

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800 450"
      height={height}
      width={width}
    >
      <ellipse id="Oval-2-Copy" fill={backgroundColor} opacity="0.4" cx="396.35" cy="278.37" rx="235.91" ry="101.87" />
      <rect
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        x="143.92"
        y="268.5"
        width="159.36"
        height="22.16"
      />
      <rect fill={iconColor} x="142.24" y="234.11" width="3.35" height="69.58" />
      <rect fill={iconColor} x="301.75" y="268.5" width="3.19" height="35.04" />
      <circle
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        cx="167.94"
        cy="255.15"
        r="13.35"
      />
      <path
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        d="M189.78,268.5V247.23s-.6-6,6-6h60.91s29-.83,29,17.46v8.51"
      />
      <rect
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        x="496.71"
        y="268.5"
        width="159.36"
        height="22.16"
      />
      <rect fill={iconColor} x="495.01" y="233.97" width="3.23" height="69.58" />
      <rect fill={iconColor} x="654.53" y="268.5" width="3.24" height="35.04" />
      <circle
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        cx="520.73"
        cy="255.15"
        r="13.35"
      />
      <path
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        d="M542.56,268.5V247.23s-.59-6,6-6h60.91s29-.83,29,17.46v8.51"
      />
      <rect
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        x="320.36"
        y="179.48"
        width="159.36"
        height="22.16"
      />
      <rect fill={iconColor} x="318.64" y="144.86" width="3.21" height="69.58" />
      <rect fill={iconColor} x="478.1" y="179.48" width="3.24" height="35.04" />
      <circle
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        cx="344.38"
        cy="166.13"
        r="13.35"
      />
      <path
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        d="M366.22,179.48V158.21s-.6-6,6-6h60.91s29-.83,29,17.46v8.51"
      />
      <rect
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        x="320.36"
        y="365.08"
        width="159.36"
        height="22.16"
      />
      <rect fill={iconColor} x="318.7" y="330.55" width="3.2" height="69.58" />
      <rect fill={iconColor} x="478.19" y="365.08" width="3.17" height="35.04" />
      <circle
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        cx="344.38"
        cy="351.73"
        r="13.35"
      />
      <path
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        d="M366.22,365.08V343.81s-.6-6,6-6h60.91s29-.83,29,17.46v8.51"
      />
      <polyline
        fill="none"
        stroke={iconColor}
        strokeMiterlimit="10"
        strokeWidth="3.32px"
        points="214.28 132.69 402.22 49.88 578.42 131.59"
      />
    </svg>
  );
}

SupplierFeatureTwo.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string
};

SupplierFeatureTwo.defaultProps = {
  width: 800,
  height: 450,
  iconColor: '#231f20',
  backgroundColor: '#52b7b0'
};

export default SupplierFeatureTwo;
